"use client";

import getImage from "@/common/function/getImage";
import { GeneralPropsType } from "@/common/types";
import clsx from "clsx";
import styles from "./index.module.css";
import { ReactNode } from "react";
import { useGlobalData } from "@/contexts/GlobalData";
import { cn } from "@/lib/utils";
export interface DetailPageLayoutPropsType extends GeneralPropsType {
  header?: ReactNode;
  disabledAnimation?: boolean;
  bgImage?: string;
  customStyles?: {
    wrapper?: React.CSSProperties;
    inner?: React.CSSProperties;
  };
  bodyClassName?: string;
  disableScroll?: boolean;
  id?: string;
  appearFrom?: "right" | "bottom" | "none";
  style?: React.CSSProperties;
  containerClassName?: string;
  pageStyle?: React.CSSProperties;
}
function DetailPageLayout({
  header,
  children,
  disabledAnimation,
  bgImage,
  className,
  customStyles,
  bodyClassName,
  disableScroll,
  id,
  appearFrom = "right",
  style,
  containerClassName,
  pageStyle
}: DetailPageLayoutPropsType) {
  const {
    statusBarHeight,
    isLimitSize,
    screenSize
  } = useGlobalData();
  return <div className={cn("fixed w-screen top-0 left-0 h-[100dvh] flex items-center justify-center detail-page-layout z-[999999]", containerClassName)} style={{
    ...(pageStyle || {})
  }} data-sentry-component="DetailPageLayout" data-sentry-source-file="index.tsx">
            <div id={id} style={{
      backgroundImage: `url(${bgImage ?? getImage("main_bg", "jpg")})`,
      ...(typeof customStyles?.wrapper === "object" ? customStyles.wrapper : {}),
      ...style,
      ...(isLimitSize ? {
        width: `${screenSize?.realWidth}px`,
        height: `${screenSize?.realHeight}px`,
        borderRadius: `${screenSize?.realWidth * 0.08}px`,
        overflow: "hidden",
        margin: "auto"
      } : {
        width: "100%",
        height: "100%"
      })
    }} className={clsx(className, {
      "!bg-cover !bg-no-repeat !bg-center flex flex-col relative z-[9999999]": true,
      [styles.right_to_left]: !isLimitSize && !disabledAnimation && appearFrom == "right",
      [styles.bottom_to_top]: appearFrom == "bottom"
    })}>
                {!!statusBarHeight && <div className="w-full" style={{
        height: `${statusBarHeight}px`
      }}></div>}
                {header}
                <div style={{
        ...(typeof customStyles?.inner === "object" ? customStyles.inner : {})
      }} className={clsx("flex-1 flex flex-col", bodyClassName, {
        "overflow-x-hidden overflow-y-scroll": !disableScroll
      })}>
                    {children}
                </div>
            </div>
        </div>;
}
export default DetailPageLayout;